import React from "react";
import { Modal, Button } from "react-bootstrap";
import './CommonConfirmModal.css';

const CommonConfirmModal = ({
  show,
  title = "Confirmation",
  message,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered className="confirm-modals">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{message}</Modal.Body>

      <Modal.Footer>
        <Button className="btns-cancel" onClick={onClose}>
          Cancel
        </Button>

        <Button className="btns-proceed" onClick={onConfirm}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommonConfirmModal;